import { render } from "./agent_detail.vue?vue&type=template&id=f4927a9e&scoped=true"
import script from "./agent_detail.vue?vue&type=script&lang=js"
export * from "./agent_detail.vue?vue&type=script&lang=js"

import "./agent_detail.vue?vue&type=style&index=0&id=f4927a9e&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/projects/sms_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4927a9e"]])

export default __exports__